import {
    HEADER_PINNED_SCROLL_Y_BREAKPOINT,
    SCROLL_Y_BREAKPOINTS
} from "../../constants";

const getPageProps = currentPage => {
    let scrollYRange;
    let secondRowHeight = { start: 0, end: 40 };
    let secondRowMarginTop = { start: 0, end: 12 };

    switch (currentPage) {
        case "home":
            scrollYRange = SCROLL_Y_BREAKPOINTS.home.headerScrollYRange;
            break;
        case "icons":
            scrollYRange = SCROLL_Y_BREAKPOINTS.icons.headerScrollYRange;
            break;
        case "photos":
            scrollYRange = SCROLL_Y_BREAKPOINTS.photos.headerScrollYRange;
            break;
        default:
            scrollYRange = SCROLL_Y_BREAKPOINTS.default.headerScrollYRange;
            secondRowHeight = { start: 40, end: 40 };
            secondRowMarginTop = { start: 12, end: 12 };
            break;
    }

    return {
        scrollYRange,
        secondRowHeight,
        secondRowMarginTop
    };
};

const getHeaderProps = currentPage => {
    const { scrollYRange, secondRowHeight, secondRowMarginTop } = getPageProps(
        currentPage
    );

    const elementProps = {
        // top position is negative inverse of the window.scrollY pixels travelled
        top: { start: 0, end: HEADER_PINNED_SCROLL_Y_BREAKPOINT * -1 },
        paddingBottom: { start: 18, end: 10 },
        secondRowHeight,
        secondRowMarginTop
    };

    return {
        top: elementProps.top.start,
        paddingBottom: elementProps.paddingBottom.start,
        secondRowHeight: elementProps.secondRowHeight.start,
        secondRowMarginTop: elementProps.secondRowMarginTop.start,
        config: {
            scrollYRange,
            elementProps
        }
    };
};

export default getHeaderProps;
